import { render, staticRenderFns } from "./BaseBotBanner.vue?vue&type=template&id=3fbfee08&scoped=true&"
import script from "./BaseBotBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBotBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseBotBanner.vue?vue&type=style&index=0&id=3fbfee08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfee08",
  null
  
)

export default component.exports